document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".featuredArticleSwiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".article-next",
      prevEl: ".article-prev",
    },
    speed: 800,
    effect: "slide",
  });
});
